import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        gallery: null,
        galleryFocus: -1
    },
    mutations: {
        SET_GALLERY: (state, images) => {
            state.gallery = images
        },
        SET_GALLERY_FOCUS: (state, i) => {
            state.galleryFocus = i
        },
        REMOVE_GALLERY: (state, images) => {
            state.gallery = null
        }
    },
    actions: {
        OPEN_GALLERY: async ({ state, commit }, { images, index }) => {
            // desktop only
            if (window.innerWidth > 720) {
                document.body.classList.add('gallery-open')
                commit('SET_GALLERY_FOCUS', index)
                commit('SET_GALLERY', images)
            }
        },
        CLOSE_GALLERY: async ({ state, commit }) => {
            document.body.classList.remove('gallery-open')
            commit('REMOVE_GALLERY')
            commit('SET_GALLERY_FOCUS', -1)
        }
    }
})
